import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "HOME" },
  { to: "/about", label: "ABOUT SPORTIVE" },
  { to: "/events", label: "EVENTS" },
  { to: "/runsafari", label: "RUNSAFARI" },
  { to: "/destinations", label: "DESTINATIONS" },
  { to: "/sports-tourism", label: "SPORTS TOURISM" },
  { to: "/partners", label: "PARTNERS & IMPACT" },
  { to: "/gallery", label: "GALLERY" },
  { to: "/stories", label: "NEWS & UPDATES" },
  { to: "/contact", label: "CONTACT" },
  { to: "/donation", label: "DONATION", accent: true },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="navbar" className="glass sticky top-0 z-50 border-b border-brand-cyan/15">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/sportive-logo.png" alt="SPORTIVE" className="h-9 w-auto object-contain drop-shadow-[0_0_14px_rgba(155,174,27,0.45)]" />
        </Link>
        <nav className="hidden items-center gap-5 xl:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                l.accent
                  ? `rounded-full border px-3 py-1.5 font-mono text-[11px] tracking-[0.12em] transition-colors ${isActive ? "border-brand-olive bg-brand-olive/15 text-brand-olive" : "border-brand-olive/40 text-brand-olive hover:bg-brand-olive/10"}`
                  : `font-mono text-[11px] tracking-[0.12em] transition-colors ${isActive ? "text-brand-cyan" : "text-slate-300 hover:text-white"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/events" data-testid="nav-register-now" className="btn-kinetic btn-primary-k hidden !px-5 !py-2 text-xs sm:inline-flex">
            REGISTER NOW
          </Link>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="text-white xl:hidden" aria-label="Menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="glass border-t border-brand-line px-6 py-4 xl:hidden">
          <div className="grid gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  l.accent
                    ? `rounded-lg border border-brand-olive/40 px-3 py-2.5 font-mono text-xs tracking-[0.15em] text-brand-olive ${isActive ? "bg-brand-olive/15" : ""}`
                    : `rounded-lg px-3 py-2.5 font-mono text-xs tracking-[0.15em] transition-colors ${isActive ? "bg-brand-cyan/10 text-brand-cyan" : "text-slate-300 hover:bg-white/5"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/events" onClick={() => setOpen(false)} className="btn-kinetic btn-primary-k mt-3 justify-center">REGISTER NOW</Link>
          </div>
        </nav>
      )}
    </header>
  );
}
